import React, { useEffect, useState } from 'react';

function TrainingVideosSection({ filteredMaterials, selectedGroup }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
const [fileName, setFileName] = useState("");


useEffect(() => {
  if (selectedMaterial?.fileUrl) {
    const name = selectedMaterial.fileUrl.split("/").pop()?.split("?")[0] || "";
    setFileName(name);
    console.log("file" ,fileName)
  }
}, [selectedMaterial]);


  // 🛑 Early return if selectedGroup is not valid
  if (selectedGroup <= 0) return null;
 

const openPopup = (material) => {
  setSelectedMaterial(material);

  if (material?.fileUrl) {
    const name = material.fileUrl.split("/").pop()?.split("?")[0] || "";
    setFileName(name); // ✅ correct
  }

  setIsOpen(true);
};


  const closePopup = () => {
    setIsOpen(false);
    setSelectedMaterial(null);
  };
 
  return (
    <div className="grid 2xl:grid-cols-5 2xl:gap-6 xl:grid-cols-3 xl:gap-4 lg:grid-cols-2 md:grid-cols-2 md:gap-4 max-xs:grid max-xs:gap-4 hd:grid-cols-4 4xl:grid-cols-6">
      {filteredMaterials
        .filter(
          (material) =>
          
            material.contentType === 'Training Video'
        )
        .map((material) => (
          <div key={material.trainingMaterialID} className="card group rounded-2xl bg-white drop-shadow-card p-4 cursor-pointer overflow-hidden">
            <img
              className="rounded-xl w-full transition-transform duration-500 transform group-hover:scale-[1.05]"
              src="images/video.png"
              alt={material.materialName}
              onClick={() => openPopup(material)}
            />
            <div className="p-4 px-0 pb-0">
              <div className="rounded-md bg-primary-100/60 text-primary-400 font-semibold py-1 px-2 xl:text-xs inline-block">
                {material.subGroupName}
              </div>
              <h5 className="block font-semibold text-[#110D1590]  pt-3 2xl:text-lg xl:text-sm md:text-base">
                {material.materialName}
              </h5>
            </div>
          </div>
        ))}

      {/* Video Popup */}
      {isOpen && selectedMaterial && (
        
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={closePopup}
        >
          <div
            className="bg-white rounded-lg p-4 w-full max-w-3xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">{selectedMaterial.materialName}</h2>
              <button
                onClick={closePopup}
                className="text-gray-600 hover:text-red-600 text-2xl font-bold"
              >
                &times;
              </button>
            </div>
    <video
   src={`https://ahcinvoicecdnend-abdvgbdmg8fnbvfz.z03.azurefd.net/ahcshaml/${encodeURIComponent(

             fileName
              )}`}
  controls
  autoPlay
  controlsList="nodownload"
  onContextMenu={(e) => e.preventDefault()}
  className="w-full rounded-lg"
/>


          </div>
        </div>
      )}
    </div>
  );
}

export default TrainingVideosSection;
